import './index.scss';

import { FacilitacaoOtimizacao } from '../../components/facilitacao-otimizacao/index';
import { OutrosProdutos } from '../../components/outros-produtos';

import { ACC } from '../../components/select-credito/acc/index';
import { ACE } from '../../components/select-credito/ace';
import { CE } from '../../components/select-credito/ce';
import { NCE } from '../../components/select-credito/nce';
import { FINIMP } from '../../components/select-credito/finimp';
import { Tabs } from '../../../tabs';
import { useState } from 'react';

export const ProdutosCredito = () => {
    const [tabId, setTabId] = useState(1)

    const tabs = [
        {
            id: 1,
            label: "ACC",
            subtitle: "Adiantamento sobre contrato de câmbio",
            content: <ACC />,
        },
        {
            id: 2,
            label: "ACE",
            subtitle: "Adiantamento sobre cambiais entregues",
            content: <ACE />,
        },
        {
            id: 3,
            label: "CE",
            subtitle: "Cédula de crédito ao exportador",
            content: <CE />,
        },
        {
            id: 4,
            label: "NCE",
            subtitle: "Nota de crédito ao exportador",
            content: <NCE />,
        },
        {
            id: 5,
            label: "FINIMP",
            subtitle: "Financiamento à importação",
            content: <FINIMP />,
        },
    ];


    return (
        <div className=''>

            <div className='container-principal credito'>
                <div className='sombra-title'>
                    <h1> [ Produtos de Crédito ] </h1>
                </div>
            </div>
            <div>
                <FacilitacaoOtimizacao />
            </div>
            <div className='restdados-cred'>
                <Tabs tabs={tabs} id={tabId} setId={setTabId} />
            </div>
            <div>
                <OutrosProdutos />
            </div>

        </div>

    )

}
